'use strict';


app.factory('Popup', ['$rootScope', 'ngDialog', 
    function ($rootScope, ngDialog) {
        var service = {};


        /**
         * open popup
         * 
         * @param String message
         * @param String type  error / success
         * @param Function callback
         */
        service.open = function(message, type, callback){

            if( message instanceof Array ){
                message = this.makeList(message);
            }

            var templateHtml;
            if (type != 'error' && type != 'success') {
                templateHtml = '<div class="error">\
                                <h3></h3>\
                                <div class="text">'+message+'</div>\
                                <div class="btn-group">\
                                    <button ng-click="closeThisDialog()" class="pull-left custom">Later</button>\
                                    <button ng-click="confirm(confirmValue)" class="custom">' + type + '</button>\
                                </div>\
                                </div>';

                ngDialog.openConfirm({
                    plain: true,
                    className: 'ngdialog-message',
                    showClose: false,
                    closeByDocument: false,
                    closeByEscape: true,
                    closeByNavigation: true,
                    template:templateHtml,
                }).then(function (confirm) {
                    if( typeof callback != 'undefined' ){   
                        ngDialog.close();
                        callback();
                    }
                }, function(reject) {
                    return;
                });
            }
            else {
                templateHtml = '<div class="'+type+'">\
                                <h3></h3>\
                                <div class="text">'+message+'</div>\
                                <button ng-click="closeThisDialog()">OK</button>\
                            </div>';

                var dialog = ngDialog.open({
                    template: templateHtml,
                    plain: true,
                    className: 'ngdialog-message',
                    showClose: false,
                    closeByDocument: false,
                    closeByEscape: true,
                    closeByNavigation: true
                });

                if( typeof callback != 'undefined' ){   
                    dialog.closePromise.then(function(data) {
                        callback();
                    });
                }
            }

            
        }


        /**
         * make unordered list from array
         * 
         * @param  Array messages
         * @return String
         */
        service.makeList = function(messages){
            var list = '<ul>';

            angular.forEach(messages, function(value, key){
                list += '<li>'+value+'</li>';
            });

            list += '</ul>';

            return list;
        }


        /**
         * open error popup
         * 
         * @param String message
         * @param Function callback
         */
        service.error = function(message, callback){
            this.open(message, 'error', callback);
        }


        /**
         * open success popup
         * 
         * @param String message
         * @param Function callback
         */
        service.success = function(message, callback){
            this.open(message, 'success', callback);
        }


        /**
         * close preloader
         */
        service.close = function(){
            ngDialog.closeAll();
        }


        service.custom = function(message, customType, callback) {
            this.open(message, customType, callback);
        }


        return service;
    }]);